import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import sbManagerStyles, { graphColors } from 'utils/globalStyles';

const DonutCardWrapper = styled.div`
  background-color: #fff;
  color: ${() => sbManagerStyles.greyDarkest};
  border: 1px solid ${() => sbManagerStyles.greyLight};
  width: 31%;
  height: 34rem;
  margin: 0 2rem 2rem 0;
  position: relative;
  padding-top: 1.5rem;
  text-align: center;
  position: relative;
  overflow: hidden;
`;

const Title = styled.h4`
  color: ${() => sbManagerStyles.greyDarkest};
  font-size: 1.8rem;
  font-weight: 500;
`;

const NoDataWrapper = styled.div`
  padding: 0 2rem;
  color: ${() => sbManagerStyles.greyMedium};
`;

const LegendStyles = {
  color: sbManagerStyles.greyDarkest,
  fontSize: '14px',
  fontWeight: '400',
  textOverflow: 'ellipsis',
  cursor: 'pointer'
};

const AnalyticsDonutCard = ({ data, style = {}, title }) => {
  const options = {
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    legend: {
      itemStyle: LegendStyles
    },
    series: [
      {
        name: title,
        type: 'pie',
        data: data.map(({ name, count }) => ({ name, y: count })),
        size: '100%',
        innerSize: '65%',
        showInLegend: true,
        dataLabels: {
          enabled: false
        },
        colors: graphColors
      }
    ]
  };

  const containerProps = { className: 'donut-card' };

  return (
    <DonutCardWrapper className="donut-card-wrapper" style={style}>
      <Title>{title}</Title>
      {data && data.length > 0 ? (
        <HighchartsReact highcharts={Highcharts} {...{ options, containerProps }} />
      ) : (
        <NoDataWrapper className="donut-card">
          No data to display. Please try selecting different filters.
        </NoDataWrapper>
      )}
    </DonutCardWrapper>
  );
};

AnalyticsDonutCard.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number
    })
  )
};

AnalyticsDonutCard.defaultProps = {
  data: []
};

export default AnalyticsDonutCard;
